import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import style from '@src/pages/Payments/Payments.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import Payment from '@src/components/Payment/Payment'
import { Select } from '@src/components/common/Select/Select'
import { AppDispatch } from '@src/store/store'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { selectPay, selectPayIsLoading } from '@src/store/ducks/pay/selectors'
import { payAndDebInfo } from '@src/store/ducks/pay/thunks'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { Datepicker } from '@src/components/common/Datepicker/Datepicker'
import { Button } from '@src/components/Button/Button'
import { setPageTitle } from '@src/store/ducks/app/reducer'

const access = [
  { value: 2, label: 'Только платежи' },
  { value: 1, label: 'Только списания' },
  { value: 0, label: 'Все операции' },
]
const PAGE_SIZE = 8

export const Payments = () => {
  const dispatch = useDispatch<AppDispatch>()
  const payments = useSelector(selectPay)
  const isLoading = useSelector(selectPayIsLoading)
  const [filterValue, setFilterValue] = useState(access[2])
  const [date, setDate] = useState({
    startDate: moment().subtract(1, 'months').format('DD.MM.YYYY'),
    endDate: moment().format('DD.MM.YYYY'),
  })

  const [index, setIndex] = useState(PAGE_SIZE)

  useEffect(() => {
    dispatch(setPageTitle('Платежи и списания | Личный кабинет для абонентов КОСМОС Телеком'))
  }, [dispatch])

  useEffect(() => {
    dispatch(payAndDebInfo(
      filterValue.value, date.startDate, moment(date.endDate, 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'),
    ))

    return () => {
      setIndex(PAGE_SIZE)
    }
  }, [dispatch, date, filterValue.value])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.paymentContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h2 className={style.mainTitle}>Платежи и списания</h2>
        <div className={style.selectContainer}>
          <Select
            options={access}
            onChange={setFilterValue}
            value={filterValue}
            className={style.selectSize}
          />
          <Datepicker date={date} setDate={setDate} maxDays={90} maxDate={moment().format()} />
        </div>

        <div className={cn(style.detailsBlock, style.detailsBlock)}>
          <div className={style.headerTable}>
            <div className={style.box}>
              <div className={style.date}>Дата</div>
              <div className={style.title}>Услуга</div>
              <div className={style.period}>Период</div>
              <div className={style.arrival}>Приход, руб.</div>
              <div className={style.spending}>Расход, руб.</div>
              <div className={style.balance}>Баланс, руб.</div>
            </div>
          </div>
          <Preloader loading={isLoading} center>
            <div className={style.paymentBlock}>
              <ul>
                {payments.payAndDeb.length ? (
                  payments.payAndDeb.slice(0, index).map((el) => (
                    <li key={el.id + el.operationDate}>
                      <Payment
                        title={el.operation}
                        balance={el.balance}
                        summa={el.summa}
                        date={moment(el.operationDate, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                        period={el.period}
                      />
                    </li>
                  ))
                ) : (
                  <div className={style.message}>
                    В данный период не производились операции по платежам и
                    списаниям. Попробуйте выбрать другой диапазон дат.
                  </div>
                )}
              </ul>
            </div>
          </Preloader>
        </div>
        {(!!payments.payAndDeb.length && index < payments.payAndDeb.length) && (
          <div className={style.btnBlock}>
            <Button
              type="secondary"
              onClickFunc={() => setIndex(index + PAGE_SIZE)}
              className={style.sizeBtn}
            >
              Показать больше
            </Button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  )
}
